// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .text-value {
    text-align: right;
    font-size: 14px;
  }
  .added-to-bag-subtotal {
    font-weight: 700;
  }
  .total-bag-points {
    letter-spacing: 0.09px;
  }
  .addedtobag-wrapper {
    min-height: 115px;
  }
  .row-padding {
    padding-bottom: 9px;
  }
  .bag-points {
    padding-bottom: 0;
  }
  .divided-line {
    height: 1px;
    background-color: ${(props) => props.theme.colorPalette.gray[1600]};
    margin-top: 0;
    margin-bottom: 9px;
  }
  .promo-color {
    color: ${(props) => props.theme.colors.PROMO.YELLOW};
  }
  &.added-to-bag-points-wrapper {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

export default styles;
